import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CITY_TITLES = {
  montreal: "Vision Sécurité Montréal | Agence de Sécurité 24/7",
  ottawa:   "Vision Security Ottawa | 24/7 Security Solutions",
  toronto:  "Vision Security Toronto | 24/7 Security Solutions",
  ontario:  "Vision Security Ontario | 24/7 Security Solutions",
  quebec:   "Vision Sécurité Québec | Agence de Sécurité 24/7",
};

const DEFAULT_TITLE = "Vision Security | 24/7 Security Solutions";

export default function useCityTitle() {
  const { pathname } = useLocation();
  // Only override the title on the homepage; other pages use <SEO> via Helmet
  const isHome = pathname === "/" || pathname === "/fr" || pathname === "/fr/";

  useEffect(() => {
    // Skip geo-personalised title during pre-rendering (react-snap / puppeteer).
    // The static title from <SEO /> is better for search-engine crawlers.
    if (navigator.userAgent.includes("HeadlessChrome")) return;

    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const city   = (data.city          || "").toLowerCase();
        const region = (data.region        || "").toLowerCase();
        const code   = (data.region_code   || "").toLowerCase();

        // Cache geo for usePageView to use without a second API call
        sessionStorage.setItem(
          "visitor_geo",
          JSON.stringify({
            city:    data.city        || null,
            region:  data.region      || null,
            country: data.country     || null,
          })
        );

        // Only set document.title on the homepage
        if (!isHome) return;

        if (city.includes("montr")) {
          document.title = CITY_TITLES.montreal;
        } else if (city.includes("ottawa")) {
          document.title = CITY_TITLES.ottawa;
        } else if (city.includes("toronto")) {
          document.title = CITY_TITLES.toronto;
        } else if (code === "on" || region.includes("ontario")) {
          document.title = CITY_TITLES.ontario;
        } else if (code === "qc" || region.includes("quebec") || region.includes("québec")) {
          document.title = CITY_TITLES.quebec;
        } else {
          document.title = DEFAULT_TITLE;
        }
      })
      .catch(() => {
        if (isHome) document.title = DEFAULT_TITLE;
      });
  }, [isHome]);
}
